var asciiWords = require("./_asciiWords"), hasUnicodeWord = require("./_hasUnicodeWord"), toString = require("./toString"), unicodeWords = require("./_unicodeWords");
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? void 0 : pattern;
  if (pattern === void 0) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}
module.exports = words;
